module.exports = __webpack_public_path__ + "00622e737b292b6409cf93ae84f0d088.svg";